import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import TileSelection from '../../common/Tile/TileSelection';
import Heading from '../../common/Heading';
import s from './StepGenericTile.module.scss';

function StepGenericTile(props) {
  const { name, msgId, mobileHeaderMsgId, tileConfigs, introMsgId, onNext } =
    props;
  return (
    <>
      {introMsgId && (
        <p className={s.intro}>
          <FormattedMessage id={introMsgId} />
        </p>
      )}
      <Heading level={2} className={`${s.heading} ${s.desktopHeading}`}>
        <FormattedMessage id={msgId} />
      </Heading>
      <Heading level={2} className={`${s.heading} ${s.mobileHeading}`}>
        <FormattedMessage id={mobileHeaderMsgId || msgId} />
      </Heading>
      <Field
        id={name}
        name={name}
        component={TileSelection}
        tileConfigs={tileConfigs}
        onNext={onNext}
      />
    </>
  );
}

StepGenericTile.defaultProps = {
  mobileHeaderMsgId: '',
  introMsgId: null,
  onNext: null,
};

StepGenericTile.propTypes = {
  /** The name of the tile selection, (is also the name of the formik id) */
  name: PropTypes.string.isRequired,
  /** the message id for internationalization of the header */
  msgId: PropTypes.string.isRequired,
  /** Some pages have a different heading for the mobile view */
  mobileHeaderMsgId: PropTypes.string,
  /** Optional intro message before the heading */
  introMsgId: PropTypes.string,
  /** tile configs */
  tileConfigs: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  onNext: PropTypes.func,
};

export default StepGenericTile;
